import { lazy } from 'react';

import { RemoteModule } from '../components/remote-module/remote-module';
import { useMessage } from '../i18n/useMessage';
import { useSessionServiceContext } from '@cld/session-service';
import { UnicornApi } from '@cld/unicorn-api';

const RemoteMonthlyValueReports = lazy(() =>
  import('@cld-remote/classic_reports/index').then(({ MonthlyValueReportsPageConnected }) => ({
    default: MonthlyValueReportsPageConnected,
  }))
);

export const MonthlyValueReports = () => {
  const t = useMessage();
  const { fetchClient } = useSessionServiceContext();

  return (
    <RemoteModule documentTitle={t('monthly-value-reports')}>
      <RemoteMonthlyValueReports fetchClient={fetchClient} />
    </RemoteModule>
  );
};
